import { Api } from 'utils';

class DocumentService {
  static admin = {
    get: async (params?: any) => Api.createResponse('admin/documents/', params),
    create: async (params?: any) =>
      Api.createResponse('admin/documents/create', params),
    delete: async (params?: any) =>
      Api.createResponse('admin/documents/delete', params),
  };
}

export default DocumentService;
